<template>
  <div
    class="mensagem-anexo-simples d-flex flex-column align-items-center px-3 py-2 rounded cursor-pointer"
    @click="abrirArquivo"
  >
    <feather-icon
      icon="FileTextIcon"
      class="text-secondary icon-grande mb-1"
      size="36"
    />
    <span class="text-primary font-weight-semibold texto-anexo">Abrir</span>
  </div>
</template>

<script>
export default {
  props: {
    url: String,
  },
  methods: {
    abrirArquivo() {
      window.open(this.url, '_blank')
    },
  },
}
</script>

  <style scoped>
  .mensagem-anexo-simples {
    background-color: #f1f1f1;
    max-width: 140px;
    text-align: center;
    transition: background-color 0.2s, box-shadow 0.2s;
  }

  .mensagem-anexo-simples:hover {
    background-color: #e6e6e6;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  }

  .icon-grande {
    min-width: 36px;
    height: 36px;
  }

  .texto-anexo {
    font-size: 0.95rem;
    line-height: 1.2;
    white-space: nowrap; /* GARANTE que "Abrir" nunca quebre de linha */
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .cursor-pointer {
    cursor: pointer;
  }
  </style>
